import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useHistory, useLocation } from "react-router-dom";
import { PaperStyled } from "./Login.styles";
import { LoginForm } from "./components/patterns/LoginForm";
import { useMst } from "../../mobx";

export default observer(function () {
  const history = useHistory();
  const location = useLocation<{ from: any }>();
  const { authStore } = useMst();
  const { isLogged } = authStore;

  useEffect(() => {
    if (isLogged) {
      const { from } = location.state || { from: { pathname: "/" } };
      history.push(from);
    }
  }, [history, isLogged, location.state]);

  return (
    <PaperStyled elevation={3}>
      <LoginForm />
    </PaperStyled>
  );
});
